import { ElementType } from 'react';

import { SearchFilterAttributeItem } from '../types/SearchFilterAttributeItem';

// use helper function to create filter item config for correct type inference of component props

type OptionalMapFunctions<C extends ElementType> = Partial<
  Pick<SearchFilterAttributeItem<C>, 'valueStateToRoute' | 'valueRouteToState'>
>;

type PartialSearchFilterAttributeItem<C extends ElementType> = OptionalMapFunctions<C> &
  Omit<SearchFilterAttributeItem<C>, 'valueStateToRoute' | 'valueRouteToState'>;

export const createSearchFilterAttributeItem = <C extends ElementType>({
  valueStateToRoute = (value) => value,
  valueRouteToState = (value) => value,
  ...item
}: PartialSearchFilterAttributeItem<C>): SearchFilterAttributeItem<C> => ({
  valueStateToRoute,
  valueRouteToState,
  ...item,
});
